import PropTypes from 'prop-types';
import { Content, Inner } from './NtaPostSubmit.styles';

const NtaPostSubmitPage = ({ children }) => (
  <Content>
    <Inner>{children}</Inner>
  </Content>
);

NtaPostSubmitPage.propTypes = {
  children: PropTypes.node.isRequired
};

export default NtaPostSubmitPage;
